/**
 * @external MomentJs
 * @see {@link https://momentjs.com/docs/|Documentation}
 */
import moment from 'moment'
import 'moment/locale/ru.js'

moment.locale('ru')

/**
 * Функция конвертирования даты в один из нижеперечисленных видов.
 * @method dateFormat
 * @param {string|Date}   date   Дата
 * @param {string}        format Формат преобразования
 *                                {'calendar'} - 'сегодня'|'01.01.2000'
 *                                {'toDate'} - Date({date})
 *                                {null|'long'} - '01 января 2000'
 * @returns {string}               Форматированную строку с датой
 */
export const dateFormat = (date, format) => {
  let dateFormat = null

  /*
   * Если date соответствует маске 'xx.xx.xxxx'
   * применяем формат даты DD.MM.YYYY
   */
  if (
    typeof date === 'string' &&
    date.length === 10 &&
    date.match(/\d{2}.\d{2}.\d{4}/)
  ) {
    dateFormat = 'DD.MM.YYYY'
  }

  let momentDate = moment(date, dateFormat)
  let result

  switch (format) {
    case 'calendar':
      result = momentDate.calendar(null, {
        sameDay: '[Сегодня]',
        nextDay: 'DD MMMM',
        nextWeek: 'DD MMMM',
        sameElse: 'DD MMMM',
      })
      break
    case 'toDate':
      result = new Date(momentDate.format('YYYY-MM-DD'))
      break
    default:
    case 'long':
      result = momentDate.format('DD MMMM YYYY')
  }

  return result
}
/**
 * Функция вывода промежутка дат
 * @param {Date|string} initDate  Дата начала
 * @param {Date|string} finalDate Дата окончания
 * @param {string}      format    Формат вывода
 * @see {@link https://momentjs.com/docs/|Documentation}
 * @returns {string}              Форматированный промежуток дат
 */
export const dateRange = (initDate, finalDate, format = 'long') => {
  let formatedInitDate = dateFormat(initDate, format)
  let formatedFinalDate = dateFormat(finalDate, format)
  let result
  if (formatedInitDate === formatedFinalDate || formatedInitDate) {
    result = dateFormat(initDate, format)
  }
  if (formatedFinalDate && formatedInitDate && formatedInitDate !== formatedFinalDate) {
    result += ' — ' + dateFormat(finalDate, format)
  }
  if (finalDate && !initDate) {
    result = dateFormat(finalDate, format)
  }
  if (result === 'Invalid date') {
    result = null
  }
  return result
}

/**
 * Вывод времени формата HH:MM.
 * @param {string} time
 * @returns {string}
 */
export const timeFormat = time => {
  time = time.split(':')
  if (time.length > 1) {
    return `${time[0]}:${time[1]}`
  }
}

/**
 * Возвращает текст с датами на основе двух дат.
 * @param {string} startDate Начальная дата доставки.
 * @param {string} [endDate] Конечная дата доставки.
 * @param {string} [separator='-'] Разделитель между начальной и текущей датой.
 * @returns {string} Текст с интервалом дат.
 */
export function getDatesIntervalText (startDate, endDate, separator = '-') {
  const timeFormats = ['YYYY-MM-DD', 'DD.MM.YYYY']
  const start = moment(startDate, timeFormats)
  const end = moment(endDate, timeFormats)
  let result = ''
  if (start.isValid() && end.isValid() && !start.isSame(end)) {
    const startFormattedDate = start.isSame(end, 'month')
      ? start.format('D')
      : start.format('D MMMM')
    result = `${startFormattedDate} ${separator || '-'} ${end.format('D MMMM')}`
  } else if (start.isValid()) {
    result = start.format('D MMMM')
  }
  return result
}
